import { NBSP } from 'shared/constants/symbols';
import * as styles from './styles.css';
import defaultImage from './assets/start-block-image.png';
import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

interface IStartBlockProps {
  image: string | null;
  device: TDeviceType;
}

export const StartBlock: React.FC<IStartBlockProps> = ({ image, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <h1 className={styles['textblock']}>
          <span className={styles['title']}>Профессионал на{NBSP}Циан:</span>
          <span className={styles['description']}>
            Пошаговый гайд по размещению и продвижению объявлений на Циан для риелторов, агентов и{NBSP}агентств{NBSP}
            недвижимости
          </span>
        </h1>

        <img
          className={styles['image']}
          src={image ?? defaultImage}
          alt="Гайд по размещению объявлений на Циан для риелторов и агентств"
        />
      </div>
    </div>
  );
};
